import { include } from './array';
import { addPathToEventPrototype } from './object';
import { addPrototypeCreate } from './string';

export default () => {
  include();
  addPrototypeCreate();
  addPathToEventPrototype()
}
